export default class SocketClient {
  constructor () {
    const { environment, base_url: baseUrl, socket_port: socketPort } = CONFIG;
    this.isSSL = (environment === 'test') || (!baseUrl.match(/[a-z]-(webrand|desygner).com/) && environment === 'prod');
    this.port = ':' + (this.isSSL ? '8888' : socketPort);
  }

  /*
   * Deprecation TODO
   *  this file duplicates lib/extended/socket-client.js
   *  please, consider switching to a unified version before modifying
   */
  openChannel ({
    channelId,
    successCallback,
    errorCallback,
    disposeOnMessage
  }, reconnectionAttempts = 0) {
    const protocol = document.location.protocol.replace('http', 'ws');
    const host = document.location.host
      .replace('desygner', 'webrand') // use socket under webrand
      .replace(/^.+\.(.+\..+)$/, '$1') // remove subdomain
    ;

    const socket = new WebSocket(`${protocol}//${host}${this.port}`);

    socket.addEventListener('open', socketOpened);
    socket.addEventListener('error', error);
    socket.addEventListener('close', error);
    socket.addEventListener('message', handleSocketMessage);

    return { dispose: finishSocketProcess };

    function socketOpened () {
      socket.send(JSON.stringify({
        channel: channelId,
        credentials: CONFIG.credentials
      }));
    }

    function error (err) {
      finishSocketProcess();

      errorCallback
        ? errorCallback(err)
        : (err.code === rejectedSubscriptionCode || reconnect());
    }

    function reconnect () {
      const reconnectTimeout = ++reconnectionAttempts * reconnectionDelay;

      setTimeout(() => socketClient.openChannel(
        { channelId, successCallback }, reconnectionAttempts
      ), reconnectTimeout);
    }

    function handleSocketMessage (event) {
      successCallback(JSON.parse(event.data).message);
      disposeOnMessage && finishSocketProcess();
    }

    function finishSocketProcess () {
      socket.removeEventListener('error', error);
      socket.removeEventListener('message', handleSocketMessage);
      socket.removeEventListener('open', socketOpened);
      socket.removeEventListener('close', error);
      socket.close();
    }
  }
}
